import * as React from "react";
function SvgLayout2Cols(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeWidth={2}
        stroke="currentColor"
        d="M1 5h30v22H1z"
      />
      <path strokeWidth={2} stroke="currentColor" d="M11 5v22" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLayout2Cols);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
